














import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'c-chips'
})
export default class Chips extends Vue {
  @Prop([String, Number]) title!: string | number
  @Prop([String, Number]) value!: string | number
}
